module.exports = "\r\n<popover\r\n\t#popover\r\n\t[hasChanges]=\"hasChanges\"\r\n\t[disabled]=\"disabled\"\r\n\t(onSave)=\"onSave($event)\"\r\n\t(onCancel)=\"onCancel()\"\r\n\t[name]=\"name\">\r\n\t\r\n\t{{displayText}}\r\n\r\n\t<select edit class=\"form-control\" [(ngModel)]=\"selectedItem\" (change)=\"popover.onChange()\" (keyup.Escape)=\"popover.onCancel()\">\r\n\t\t<option *ngFor=\"let item of items\" [ngValue]=\"item\">{{item.text}}</option>\r\n\t</select>\r\n\r\n</popover>";


//////////////////
// WEBPACK FOOTER
// ./TypeScript/shared/editable-popover/specialized/classification-code-dropdown.component.html
// module id = 427
// module chunks = 10